module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('select', {
    staticClass: "form-control select-box",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "click": _vm.onClick
    }
  }, _vm._l((_vm.fieldOptions), function(o) {
    return _c('option', {
      key: o,
      attrs: {
        "data": o,
        "val": "."
      },
      domProps: {
        "selected": o == _vm.fieldValue
      }
    }, [_vm._v(_vm._s(_vm.specialLabels(o)))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b5cde0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/select-box.vue
// module id = 929
// module chunks = 0